import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import lastOperationsIcon from './../../../img/last-operations-icon.png';
import { newRequest, request } from './../../../../../config';
import YesNoModal from '../../../../../copms/Modal/YesNoModal';
import Loading from '../../../Loading/Loading';
import { Autocomplete, TextField } from '@mui/material';

class AddCardVisaPlus extends Component {
    state = {
        open: false,
        operations: [],
        cards: [],
        cardId: null,
        cardNumber: '',
        mobile: '',
        step: 1
    }

    componentWillMount() {
        this.setState({ isLoading: true });
        if (localStorage.getItem('custObject')) {
            let custObject = JSON.parse(localStorage.getItem('custObject'));
            let mobile = (custObject.customer !== undefined) ? custObject.customer.mobile : custObject.mobile;
            if (mobile !== null && mobile !== undefined) {
                mobile = '+' + mobile.slice(0, 3) + ' (' + mobile.slice(3, 5) + ') ' + mobile.slice(5, 8) + '-' + mobile.slice(8, 10) + '-' + mobile.slice(10, 12);
            }
            this.setState({ mobile });
        }
        this.getVisaDirectCardList();
    }

    addCard = (preferred) => {
        this.setState({ isLoading: true });
        let requestBody = {
            cardId: this.state.cardId,
            preferred
        }
        fetch(newRequest(`visa/api/ads/aliases/${this.props.match.params?.id}/paymentCredentials`, requestBody))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode !== 1) {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode));
                        this.setState({ isLoading: false, open: false });
                    }
                }
                else {
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(response.status.statusCode), null, null, () => this.props.history.push("/dashboard/transfer/visa-plus/settings"));
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getVisaDirectCardList = () => {
        let requestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            custId: localStorage.getItem('custId')
        }
        fetch(request("card/getVisaDirectCardList", requestBody))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode !== 1 && response.status.statusCode !== 137) {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode));
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    if (response.status.statusCode === 137) {
                        response.cardList = [];
                    }
                    this.setState({ cards: response.cardList, isLoading: false });
                }
            },
                (error) => {

                    this.props.history.push("/technical-break");
                });
    }

    // componentDidMount() {
    // }

    render() {
        let { t } = this.props;
        let { open, isLoading, cards, cardId, cardNumber, mobile } = this.state;
        return (
            <Fragment>
                <YesNoModal ok={t('Köçürmələri bu karta al')} notOk={t('Hal-hazırda seçilmiş kartla davam et')}
                    title={t("Əsas kartın təyin edilməsi")}
                    body={t("Visa add card text", { cardNumber })}
                    open={open} onClose={(val) => !val && this.addCard(0)} triggerFunc={() => this.addCard(1)} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Visa+ money transfers')}</h2>
                    </div>
                </div>
                {isLoading ?
                    <div className="dashboard-container-main-section">
                        <Loading />
                    </div>
                    :
                    <div className="dashboard-container-main-section">
                        <div className="dashboard-account-container dashboard-container-main-section-home-left mw-100 bg-white">
                            <div className="dashboard-account-container-component">
                                <h3>{t('Yeni Alias')}</h3>
                                <Autocomplete
                                    sx={{ width: 320, '.MuiOutlinedInput-root': { background: 'white' }, '.MuiInputLabel-root': { color: '#1976d2' } }}
                                    options={cards || []}
                                    getOptionLabel={card => card.cardNumber + " / " + card.balance + " " + card.currency}
                                    // value={data?.accountList?.find(item => item.accountId == accountId) || null}
                                    onChange={(event, value) => this.setState({ cardId: value?.cardId, cardNumber: value?.cardNumber })}
                                    disableClearable
                                    renderInput={(params) => <TextField label={t('Card')} {...params} />}
                                />
                                <TextField value={localStorage.getItem('fullname').split(' ')[1]} sx={{ width: 230 }} InputProps={{ readOnly: true }} label={t('name')} />
                                <TextField value={localStorage.getItem('fullname').split(' ')[0]} sx={{ width: 230 }} InputProps={{ readOnly: true }} label={t('surname')} />
                                <TextField value={mobile} sx={{ width: 230 }} InputProps={{ readOnly: true }} label={t('phone number')} />
                                <div className="dashboard-salary-order-container-box w-100">
                                    <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main ml-auto" disabled={!cardId} onClick={() => this.setState({ open: true })}>{t("continue")}</button>
                                    <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-outline" onClick={() => this.props.history.goBack()}>{t("Back")}</button>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard-currency-convertor-calendar-section bg-white">
                            <div className="dashboard-finance-section-card-section-details-section-header">
                                <h3 className="dashboard-finance-section-card-section-details-section-header-title dashboard-last-operations-section-header-title">{t('How are money transfers made via Visa+?')}</h3>
                            </div>
                            <div className="dashboard-last-operations-section-content">
                                <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image w-75" alt="lastOperationsIcon" />
                                <p className="dashboard-last-operations-section-content-status">{t('visa+ text')}</p>
                            </div>
                        </div>
                    </div>
                }
            </Fragment>
        )
    }
}

export default translate("translation")(AddCardVisaPlus);